import { types } from "mobx-state-tree";
import { IdEntity } from "modules/common/models/entity";
import { NotificationType } from "modules/common/services/notifications/types";

let ID = 1;

export const Notification = types
    .compose(
        IdEntity,
        types.model({
            type: types.enumeration<NotificationType>(["error", "info", "success", "warning"]),
            message: types.string,
            /** Ссылка на объект уведомления: открывается в новой вкладке */
            link: types.optional(types.string, ""),
            /** Части уведомления: о чём оно (договор, доска)... */
            context: types.optional(types.string, ""),
            /** ...про что именно (задание с номером и названием)... */
            title: types.optional(types.string, ""),
            /** ...и что произошло, по строке на событие. Без заголовка показывается message */
            details: types.optional(types.array(types.string), []),
            /** Подпись кнопки ссылки */
            linkText: types.optional(types.string, ""),
        })
    )
    .named("Notification");

/** Части уведомления, которые сервер присылает вместе с текстом */
export interface NotificationParts {
    context?: string;
    title?: string;
    details?: string[];
    linkText?: string;
}

export const NotificationStore = types
    .model("NotificationStore", {
        alerts: types.array(Notification),
    })
    .actions((self) => ({
        closeNotification(id: string) {
            const notification = self.alerts.find((a) => a.id === id);
            if (notification) {
                self.alerts.remove(notification);
            }
        },
        addNotification(type: NotificationType, message: string) {
            // if (!self.alerts.find((a) => a.message === message)) {
            self.alerts.push({
                id: (ID++).toString(),
                type,
                message,
            });
            //   }
        },
        addInfoNotification(type: NotificationType, message: string, link = "", parts?: NotificationParts | null) {
            if (!self.alerts.find((a) => a.message === message)) {
                self.alerts.push({
                    id: (ID++).toString(),
                    type,
                    message,
                    link,
                    context: parts?.context || "",
                    title: parts?.title || "",
                    details: parts?.details || [],
                    linkText: parts?.linkText || "",
                });
            }
        },
    }));

export const initialState = (): typeof NotificationStore.SnapshotType => ({
    alerts: [],
});

export type NotificationStoreType = typeof NotificationStore.Type;
